(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  document.querySelectorAll('form[data-confirm]').forEach(function (f) {
    f.addEventListener('submit', function (e) { if (!window.confirm(f.dataset.confirm)) e.preventDefault(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (function () {
    var bar = document.querySelector('.read-progress');
    var body = document.querySelector('.marticle__content');
    if (!bar || !body || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var raf = 0;
    function update() {
      raf = 0;
      var r = body.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (innerHeight * 0.4 - r.top) / r.height));
      bar.style.setProperty('--read', p.toFixed(4));
    }
    addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  (function () {
    var box = document.querySelector('[data-shipping-estimate] form');
    if (!box) return;
    box.addEventListener('submit', function (e) {
      e.preventDefault();
      var out = box.querySelector('[data-rates]'), data = new FormData(box);
      var q = new URLSearchParams(); data.forEach(function (v, k) { q.append(k, v); });
      out.textContent = '…';
      fetch('/cart/shipping_rates.json?' + q).then(function (r) { return r.json(); }).then(function (j) {
        if (!j.shipping_rates) { out.textContent = Object.values(j).join(' '); return; }
        out.innerHTML = '';
        j.shipping_rates.forEach(function (rate) { var p = document.createElement('p'); p.textContent = rate.name + ': ' + (window.NS && NS.money ? NS.money(Math.round(rate.price * 100)) : rate.price); out.appendChild(p); });
        if (!j.shipping_rates.length) out.textContent = '-';
      }).catch(function () { out.textContent = ''; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  document.querySelectorAll('[data-readmore]').forEach(function (box) {
    var inner = box.firstElementChild, btn = box.querySelector('button');
    if (!btn || inner.scrollHeight < 200) return;
    box.classList.add('is-clamped'); btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-clamped') === false;
      btn.setAttribute('aria-expanded', open);
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    var l = document.getElementById("LoginPanel"), r = document.getElementById("RecoverPanel");
    if (!l || !r) return;
    function show(recover) { l.hidden = recover; r.hidden = !recover; (recover ? r : l).querySelector("input").focus(); }
    if (location.hash === "#recover" || r.querySelector(".form-success, .form-error")) show(true);
    document.querySelectorAll("[data-account-toggle]").forEach(function (a) { a.addEventListener("click", function (e) { e.preventDefault(); show(a.getAttribute("href") === "#RecoverPanel"); }); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    var form = document.querySelector('.main-product [data-add-button]');
    if (!form) return;
    new IntersectionObserver(function (entries) {
      var shown = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-shown', shown);
      bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
      bar.querySelector('[data-sticky-add]').tabIndex = shown ? 0 : -1;
    }).observe(form);
    bar.querySelector('[data-sticky-add]').addEventListener('click', function () {
      if (form.disabled) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      form.closest('form').requestSubmit ? form.closest('form').requestSubmit(form) : form.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  document.querySelectorAll('[data-recs]').forEach(function (sec) {
    if (sec.dataset.loaded) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect(); sec.dataset.loaded = 1;
      fetch(sec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs-body]');
        if (fresh && fresh.querySelector('.card__title')) {
          sec.querySelector('[data-recs-body]').innerHTML = fresh.innerHTML;
          document.dispatchEvent(new CustomEvent('ns:dom-updated', { detail: sec }));
        } else { sec.hidden = true; }
      }).catch(function () { sec.hidden = true; });
    }, { rootMargin: '400px 0px' });
    io.observe(sec);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-depth-rail]').forEach(function (rail) {
      if (rail.closest('[data-motion-level="none"]')) return;
      var items = rail.children, raf = 0;
      function update() {
        raf = 0;
        var r = rail.getBoundingClientRect(), mid = r.left + r.width / 2;
        for (var i = 0; i < items.length; i++) {
          var b = items[i].getBoundingClientRect();
          var off = (b.left + b.width / 2 - mid) / (r.width / 2);
          var clamped = Math.max(-1, Math.min(1, off));
          items[i].style.setProperty('--depth', Math.abs(clamped).toFixed(3));
          items[i].style.setProperty('--tilt', (-clamped).toFixed(3));
        }
      }
      rail.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
      new ResizeObserver(update).observe(rail);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
